<template>
    <!--<header id="top_info" class="header" role="navigation">
        <div id="top_info_bg"></div>
        <div class="container header-games">
            <div class="top-fullscreen pull-right">
                <a id="cash_out_btn" @click="open=user.balance>0" class="top-fullscreen-btn" data-toggle="modal"
                   data-target="#myModal1">
                    <img src="~/../../assets/images/ekioska/cash-out.png">
                </a>
            </div>
            <pay-in-component v-bind:view="pay" v-on:view-change="pay=!pay"
                              v-on:balance-change="balance" v-on:status-change="checkStatus"></pay-in-component>
            <modal class="modal-cash-out" v-model="open" title="Confirmation" size="sm">
                <p>Do you want cash out?</p>
                <div slot="footer">
                    <btn @click="cashOut">OK</btn>
                    <btn @click="open=false">Cancel</btn>
                </div>
            </modal>
            <div class="container">
                <div class="top-logout pull-left" v-if="!playing">
                    <a data-logout href class="top-logout-btn" @click="logout">
                        <i class="btn btn-border btn-icon icon-power"></i>
                    </a>
                </div>
                <div class="top-logout pull-left" v-if="!playing">
                    <a data-logout class="top-logout-btn" @click="pay=true">
                        <i class="btn btn-border btn-icon icon-paypal"></i>
                    </a>
                </div>
                <div class="top-home pull-left" v-if="playing" @click="home">
                    <a class="top-home-btn">
                        <i class="btn btn-border btn-icon icon-home"></i>
                    </a>
                </div>
                <div class="top-account-info">
                    <div class="pill top-entries">
                        <span class="name user-name">User</span>
                        <span class="num user-num">{{user.name}}</span>
                    </div>
                    <div class="pill top-ballance">
                        <span class="name balance-name">Balance</span>
                        <span class="num balance-num"
                              id="ballanceLink"><span>{{user.currency}}{{user.balance}}</span></span>
                    </div>
                </div>
            </div>
        </div>
    </header>-->

    <div class="row header-games-xs header-games-md" role="navigation">
        <div class="col-xs-3 col-sm-3 col-md-1 col-lg-1 pull-left header-element-xs header-element-md">
            <div class="row">
                <div class="col-xs-6 col-sm-6 col-md-6 header-button" v-if="!playing">
                    <a data-logout href @click="logout">
                        <i class="btn btn-border btn-icon icon-power"></i>
                    </a>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 header-button" v-if="playing">
                    <a class="top-home-btn" @click="home">
                        <i class="btn btn-border btn-icon icon-home"></i>
                    </a>
                </div>
                <div class="col-xs-6 col-sm-6 col-md-6 header-button" v-if="!playing && settings.cashIn">
                    <a data-logout class="top-logout-btn" @click="pay=true">
                        <i class="btn btn-border btn-icon icon-paypal"></i>
                    </a>
                </div>
            </div>
        </div>
        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>

        <div class="col-xs-3 col-sm-3 col-md-4 col-lg-3 pill header-element-xs header-element-md">
            <div class="row text-center account-div">
                <div class="col-xs-4 col-sm-6 col-md-6 name user-name account-label-xs account-label-sm account-label-md">
                    User
                </div>
                <div class="col-xs-8 col-sm-6 col-md-6 num user-num account-info-xs account-info-sm account-info-md">
                    {{user.name}}
                </div>
            </div>
        </div>
        <div class="col-xs-4 col-sm-4 col-md-4 col-lg-3 pill header-element-xs header-element-md">
            <div class="row text-center account-div">
                <div class="col-xs-5 col-sm-6 col-md-6 name balance-name account-label-xs account-label-sm account-label-md zero-padding">
                    Balance
                </div>
                <!--<span class="num balance-num"
                      id="ballanceLink"><span class="account-info-xs account-info-sm account-info-md">{{user.currency}}{{user.balance}}</span></span>-->
                <div class="col-xs-7 col-sm-6 col-md-6 num user-num account-info-xs account-info-sm account-info-md zero-padding">
                    {{user.currency}}{{user.balance}}
                </div>
            </div>
        </div>

        <div class="col-xs-0 col-sm-0 col-md-1 col-lg-2"></div>
        <div class="col-xs-2 col-sm-2 col-md-1 col-lg-1 pull-right header-element-xs header-element-md"
             v-if="settings.cashOut">
            <a id="cash_out_btn" @click="open=user.balance>0" class="top-fullscreen-btn">
                <img src="~/../../assets/images/ekioska/cash-out.png">
            </a>
        </div>
        <div class="container" v-if="open || pay">
            <pay-in-component v-bind:view="pay" v-on:view-change="pay=!pay"
                              v-on:balance-change="balance" v-on:status-change="checkStatus"></pay-in-component>
            <cash-out-component v-bind:view="open" v-on:view-change="open=!open"></cash-out-component>
        </div>
    </div>

</template>
<script>
    import RemoteService from './../service/RemoteService.js'
    import PayInComponent from './../pay-in-component/PayInComponent.vue'
    import CashOutComponent from './../cash-out-component/CashOutComponent.vue'


    const BALANCE_POLL = 5 * 1000;
    export default {
        components: {PayInComponent, CashOutComponent},
        dependencies: ['service'],
        props: ["playing"],
        data: function () {
            return {
                user: {
                    name: '~',
                    balance: 0,
                    currency: '$',
                    fullscreen: false
                },
                timer: null,
                open: false,
                pay: false,
                settings: {
                    cashIn: settings.cashIn,
                    cashOut: settings.cashOut
                }
            }
        },
        mounted: function () {
            this.user.name = sessionStorage.name;
            this.user.currency = sessionStorage.currency;
            this.balance();
            this.timer = setInterval(this.balance, BALANCE_POLL);
            document.addEventListener("fullscreenchange", e => {
                if (document.fullscreenElement) {
                    this.fullscreen = true;
                } else {
                    this.fullscreen = false;
                }
            });
            if (this.settings.cashIn && this.settings.cashOut)
                this.checkStatus();
        },
        destroyed() {
            console.log('destroy')
            if (this.timer) clearInterval(this.timer);
        },
        methods: {
            home() {
                this.$emit('home');
            },
            logout() {
                sessionStorage.removeItem('username');
                sessionStorage.removeItem('password');
                this.service.logout().then(() => {
                }).catch(() => {
                })
                this.$router.push('');
            },
            balance() {
                this.service.getBalance().then(r => {
                    this.user.balance = r.data.balance;
                }).catch(error => {
                    if (error.response) {
                        console.log(error.response.status);
                    } else {
                        console.log('Error', error.message);
                    }
                    this.$router.push('/');
                });
            },
            fullScreen() {
                if (this.fullscreen == true) {
                    this.closeFullscreen();
                    this.fullscreen = false;
                } else {
                    this.goFullscreen(document.body);
                    this.fullscreen = true;
                }

            },
            goFullscreen(elem) {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen();
                }
            },
            closeFullscreen() {
                if (document.fullscreenElement) {
                    document.exitFullscreen();
                } else if (document.mozCancelFullScreen) { /* Firefox */
                    document.mozCancelFullScreen();
                } else if (document.webkitExitFullscreen) { /* Chrome, Safari and Opera */
                    document.webkitExitFullscreen();
                } else if (document.msExitFullscreen) { /* IE/Edge */
                    document.msExitFullscreen();
                }
            },
            checkStatus() {
                this.service.status().then(r => {
                    if (r.data.errorCode == 0) {
                    }
                });
            }
        }
    }
</script>